import type { ContentAPI } from "generated/types";
import type {
  ScheduledTestBasePayload,
  ScheduledTestCreatePayload,
  ScheduledTestDetails,
} from "models/exam/ScheduledTest";
import type { ProductTestGroupType } from "models/product/ProductTestGroups";
import type { ScheduledTestRequestFormValues } from "./form/ScheduledTestRequestForm.model";
import type { FormValues } from "./steps/FormStep.model";

export const parsePayload = (values: ScheduledTestRequestFormValues): ScheduledTestBasePayload => ({
  testId: values.testId as number,
  title: values.title,
  extraTime: values.extraTime || 0,
  reviewStartDate: values.reviewStartDate,
  reviewEndDate: values.reviewEndDate,
  passingScore: values.passingScore,
  password: values.password || null,
  reviewPassword: values.reviewPassword || null,
  cumulative: values.cumulative,
  editableAnswers: values.editableAnswers,
  supportMessage: values.message,
  sebKeyIds: values.sebKeyIds,
  schoolyearEnabled: values.schoolyearEnabled,
});

export const parseCreatePayload = (
  values: ScheduledTestRequestFormValues,
): ScheduledTestCreatePayload => ({
  ...parsePayload(values),
  schedule: values.schedule,
});

export const parseUpdatePayload = (
  values: ScheduledTestRequestFormValues,
): ContentAPI.UpdateScheduledTest => ({
  ...parsePayload(values),
  reviewStartDate: values.reviewStartDate?.toISOString(),
  reviewEndDate: values.reviewEndDate?.toISOString(),
  startDate: values.schedule[0].startDate.toISOString(),
  duration: values.schedule[0].duration,
  estimatedStudents: values.schedule[0].estimatedStudents,
});

export const scheduledTestToFormValues = (
  scheduledTest: ScheduledTestDetails,
): ScheduledTestRequestFormValues => ({
  productId: scheduledTest.productId,
  testType: scheduledTest.testType as ProductTestGroupType,
  testId: scheduledTest.testId,
  title: scheduledTest.title,
  estimatedStudents: scheduledTest.estimatedStudents || 0,
  extraTime: scheduledTest.extraTime > 0 ? scheduledTest.extraTime : null,
  useCustomReviewDate: !!scheduledTest.reviewStartDate || !!scheduledTest.reviewEndDate,
  reviewStartDate: scheduledTest.reviewStartDate ? new Date(scheduledTest.reviewStartDate) : null,
  reviewEndDate: scheduledTest.reviewEndDate ? new Date(scheduledTest.reviewEndDate) : null,
  passingScore: scheduledTest.passingScore,
  password: scheduledTest.password === null ? "" : scheduledTest.password,
  reviewPassword: !scheduledTest.reviewPassword ? "" : scheduledTest.reviewPassword,
  cumulative: scheduledTest.cumulative,
  editableAnswers: scheduledTest.editableAnswers,
  sebKeyIds: scheduledTest.sebKeyIds,
  schedule: [
    {
      startDate: new Date(scheduledTest.startDate),
      duration: scheduledTest.duration,
      estimatedStudents: scheduledTest.estimatedStudents,
    },
  ],
  message: "",
  schoolyearEnabled: scheduledTest.schoolyearEnabled || false,
});

export const getDefaultScheduledTestRequestFormValues = (): FormValues => ({
  title: "",
  proctoring: [],
  testType: "summative-test" as ProductTestGroupType,
  schedule: [],
  cumulative: false,
  editableAnswers: true,
  message: "",
  schoolyearEnabled: false,
});
